import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';

import { ToastComponent } from '../shared/toast/toast.component';
import { AuthService } from '../services/auth.service';
import { ee } from '../shared/constants';
import { removeTooltipElement } from '../shared/functions';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  standalone: false
})
export class ResetPasswordComponent implements OnInit, OnDestroy {
  private auth = inject(AuthService);
  private router = inject(Router);
  toast = inject(ToastComponent);


  currentContent = 'reset-password';
  menuItems = [
    { name: 'Reset password', link: 'reset-password', icon: 'sign-in' },
  ];

  ngOnInit(): void {
    if (this.auth.loggedIn) {
      this.router.navigate(['/']);
    }
    ee.on('changeContent', (data: string) => this.currentContent = data);
  }

  ngOnDestroy(): void {
    ee.off('changeContent', () => {});
    removeTooltipElement();
  }

}
